import React, { FC } from 'react';

const cobrowseStyle = {
  backgroundColor: '#019ada',
  borderRadius: '16px',
  color: 'white',
  cursor: 'pointer',
  lineHeight: '32px',
  padding: '0 10px',
  margin: '5px 5px',
  minWidth: '115px',
  'text-align': 'center',
};

const presenceStyle = {
  ...cobrowseStyle,
  '-webkit-animation-name': 'orangePulse',
  '-webkit-animation-duration': '2s',
  '-webkit-animation-iteration-count': 'infinite',
};

const endStyle = {
  ...cobrowseStyle,
  backgroundColor: '#B40617',
};

interface JoinButtonProps {
  inSession: boolean;
  present: boolean;
  haveKey: boolean;
  join: () => void;
  loadingCobrowse: boolean;
  display: boolean;
}

const CobrowseJoinButton: FC<JoinButtonProps> = (
  joinButtonProps: JoinButtonProps
) => {
  const { inSession, present, haveKey, join, loadingCobrowse, display } =
    joinButtonProps;

  const presence = present && !haveKey && !loadingCobrowse;
  const style = inSession ? endStyle : presence ? presenceStyle : cobrowseStyle;

  return display ? (
    <div style={style} onClick={join}>
      {inSession ? 'End Session' : loadingCobrowse ? 'Cancel' : 'Join'}
    </div>
  ) : null;
};

export default CobrowseJoinButton;
